import { c as _c } from "react/compiler-runtime";
import { AboutSection } from "@/components/section/AboutSection";
import { ContactSection } from "@/components/section/contact/ContactSection";
import { HeroSection } from "@/components/section/HeroSection";
import { JourneySection } from "@/components/section/journey/JourneySection";
import { SectionSeparator } from "@/components/section/SectionSeparator";
import { WorkSection } from "@/components/section/WorkSection";
import { NAVIGATION_ITEMS } from "@/utils/constants";
import { NavigationItem } from "@/utils/interfaces";
import { Fragment } from "react";
const renderSectionContent = (item: NavigationItem) => {
  switch (item.id) {
    case NAVIGATION_ITEMS[0].id:
      return <AboutSection />;
    case NAVIGATION_ITEMS[1].id:
      return <JourneySection title={item.label} />;
    case NAVIGATION_ITEMS[2].id:
      return <WorkSection title={item.label} />;
    case NAVIGATION_ITEMS[3].id:
      return <ContactSection />;
    default:
      return null;
  }
};
export default function Home() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><section id="hero-section" className="min-h-screen flex flex-col justify-center items-center p-8 md:px-24 w-full"><HeroSection /></section><SectionSeparator />{NAVIGATION_ITEMS.map(_temp)}</>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(item, index) {
  const isLastSection = index === NAVIGATION_ITEMS.length - 1;
  return <Fragment key={item.id}><section id={item.sectionId} className="min-h-screen flex flex-col justify-center items-center p-8 md:px-24 w-full gap-8">{renderSectionContent(item)}</section>{!isLastSection && <SectionSeparator />}</Fragment>;
}